import React, { useRef, useState } from 'react';
import { useDetectOutsideClicks } from '../hooks/use-detect-outside-clicks';

type Props = {
  children: (
    expanded: boolean,
    setExpanded: (expanded: boolean) => void,
  ) => React.ReactElement<any>;
  extraInsideElements?: HTMLElement[];
  className?: string;
};

export const ExpandableWidgetContainer = (props: Props) => {
  const { children, extraInsideElements, className } = props;

  const [expanded, setExpanded] = useState(false);
  const divRef = useRef<HTMLDivElement | null>(null);
  useDetectOutsideClicks(
    () => setExpanded(false),
    divRef.current,
    extraInsideElements,
  );

  return (
    <div ref={divRef} className={className || ''}>
      {children(expanded, setExpanded)}
    </div>
  );
};
